"use client";
import { cn } from "@/lib/utils";
import { HorizontalGradient } from "@/components/horizontal-gradient";
import { FeaturedTestimonials } from "@/components/featured-testimonials";
import { useLocale } from "next-intl";

const sideContent = {
  en: {
    heading: "Trusted by sales teams worldwide",
    body: "Coldfire helps sales teams call smarter, document automatically, and close more deals with powerful workflow automation.",
  },
  de: {
    heading: "Von Vertriebsteams weltweit vertraut",
    body: "Coldfire hilft Vertriebsteams, intelligenter zu telefonieren, Anrufe automatisch zu dokumentieren und mehr Deals abzuschließen.",
  },
};

export function AuthLayout({ children }: { children: React.ReactNode }) {
  const locale = useLocale();
  const c = locale === "de" ? sideContent.de : sideContent.en;

  return (
    <>
      <div className="w-full min-h-screen grid grid-cols-1 md:grid-cols-2">
        {children}
        <div className="relative w-full z-20 hidden md:flex border-l border-neutral-100 dark:border-neutral-800 overflow-hidden bg-gray-50 dark:bg-neutral-900 items-center justify-center">
          <div className="max-w-sm mx-auto">
            <FeaturedTestimonials />
            <p className={cn("font-semibold text-xl text-center text-muted dark:text-muted-dark")}>
              {c.heading}
            </p>
            <p className={cn("font-normal text-base text-center text-neutral-500 dark:text-neutral-400 mt-8")}>
              {c.body}
            </p>
          </div>
          <HorizontalGradient className="top-20" />
          <HorizontalGradient className="bottom-20" />
          <HorizontalGradient className="-right-80 transform rotate-90 inset-y-0 h-full scale-x-150" />
          <HorizontalGradient className="-left-80 transform rotate-90 inset-y-0 h-full scale-x-150" />
        </div>
      </div>
    </>
  );
}
